import React from "react";
import styles from "../pricingHeader/PricingHeader.module.scss";
import CheckBox from "../../../../shared/checkBox/CheckBox";
import Item from "../../../../shared/item/Item";
import SortingIcon from "../../../../shared/sortingIcon/SortingIcon";
import { Table, TableHead } from "@material-ui/core";
import {
  CheckBoxTableCellHeader,
  NonEditTableHeader,
  PermissionHeader,
  SpecsTableHeaderPricingDetails,
  WarningTableCell,
} from "../../../../shared/pricing/dealerFees/TableComponents";
import HasPermissionTo from "../../../../common/HasPermissionTo";

const OptionsHeader = (props) => {
  const headers = [
    {
      id: "yearItem",
      key: "year",
      translation: props.t("Options.year"),
      sorting: true,
    },
    {
      id: "RRPItem",
      key: "rrp",
      translation: props.t("Options.rrp"),
      sorting: true,
    },
    {
      id: "VMItem",
      key: "vm",
      translation: props.t("Options.discount"),
      sorting: true,
    },
    { id: "adjustment" },
    {
      id: "recommendedPrice",
      key: "recommendedPrice",
      translation: props.t("Options.recommendedPrice"),
      sorting: true,
    },
  ];

  function tableHeader(header) {
    return (
      <NonEditTableHeader
        id={header.id}
        className={header.variableMarketing && styles.vehiclesShadowRow}
        onClick={() => props.onClick(header.key)}
      >
        <div
          className={`${styles.vehiclesHeaderWrap} ${styles.vehiclesHeader}`}
        >
          <Item className={styles.headerWidth} value={header.translation} />
          <span className={styles.sorting}>
            <SortingIcon
              currentKey={header.key}
              hide={
                header.id === "yearItem"
                  ? !(
                      Array.isArray(props.catalogIds) &&
                      props.catalogIds.length > 1
                    )
                  : props.isEditEnabled
              }
              sortKey={props.sortKey}
              sortDirection={props.sortDirection}
            />
          </span>
        </div>
      </NonEditTableHeader>
    );
  }

  function dealerAdjustment() {
    return (
      <PermissionHeader
        {...props}
        condition={!props.readOnly}
        editEnabled={props.isEditEnabled}
        headerTestId="recommendedAdjustmentUpdateHeader"
        headerText={props.t("Options.recommendedAdjustment")}
        updateText={props.t("Options.update")}
        bodyText={props.t("Options.recommendedAdjustment")}
        noRenderText={props.t("Options.recommendedAdjustment")}
        cancelTestId="cancelOptions"
        confirmTestId="confirmOptions"
        editTestId="editOptions"
      />
    );
  }

  return (
    <div className={styles.rowBorder}>
      <Table>
        <TableHead>
          <WarningTableCell />
          <CheckBoxTableCellHeader className={styles.rowItem}>
            <CheckBox
              className="toggleAllCheckbox"
              id="toggleAllCheckbox"
              checked={false}
              isDisabled={props.isDisabled}
            />
          </CheckBoxTableCellHeader>
          <SpecsTableHeaderPricingDetails
            onClick={() => props.onClick("specs")}
          >
            <div className={styles.specsHeaderWrap}>
              <Item value={props.t("Options.specification")} />
              <span className={styles.sorting}>
                <SortingIcon
                  hide={props.isEditEnabled}
                  currentKey="featureAsc"
                  sortKey={props.sortKey}
                  sortDirection={props.sortDirection}
                />
              </span>
            </div>
          </SpecsTableHeaderPricingDetails>
          {headers.map((header) => {
            if (header.id !== "adjustment") {
              return tableHeader(header);
            } else {
              return (
                <HasPermissionTo
                  perform={["dealerAdjustment"]}
                  permissions={props.user.permissions.rolePermissions}
                  render={() => {
                    return dealerAdjustment();
                  }}
                />
              );
            }
          })}
        </TableHead>
      </Table>
    </div>
  );
};

export default OptionsHeader;
